export enum PRIVILEGE_ATTACHMENT_TYPE {
  ROLE = 'ROLE',
  RULE = 'RULE',
}
